
import styled from "styled-components";

export const Container = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    width: 100dvw;
    height: 100dvh;
    background: #000;
    z-index: 999;
`